import React from 'react';

import Link from 'components/Link';

import 'styles/MainFooter.scss';

const MainFooter = () => {
  return (
    <footer className="MainFooter is-inside-app">
      <div className="footer-menu">
        <div className="wrapper-full">
          <nav>
            <div className="grid-column">
              <a className="Link" target="_blank" href={`${process.env.KOOTH_UNAUTH_URL}/team.html`}>{__('footer.menuTitleTeam')}</a>
            </div>
            <div className="grid-column">
              <a className="Link" target="_blank" href={`${process.env.KOOTH_UNAUTH_URL}/privacy.html`}>{__('footer.menuTitlePrivacy')}</a>
            </div>
            <div className="grid-column">
              <a className="Link" target="_blank" href={`${process.env.KOOTH_UNAUTH_URL}/confidentiality.html`}>{__('footer.menuTitleConfidentiality')}</a>
            </div>
            <div className="grid-column">
              <a className="Link" target="_blank" href={`${process.env.KOOTH_UNAUTH_URL}/terms.html`}>{__('footer.menuTitleTerms')}</a>
            </div>
            <div className="grid-column">
              <Link to="/feedback">{__('footer.menuTitleFeedback')}</Link>
            </div>
          </nav>
        </div>
      </div>
      <div className="copyright-info">
        <div className="wrapper-full">
          &copy; <a className="Link" target="_blank" href={__('footer.copyrightLinkUrl')}>{__('footer.copyrightLinkText')}</a> {(new Date()).getFullYear()}
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;



/** WEBPACK FOOTER **
 ** ./src/members/Main/MainFooter/index.js
 **/